import { Form } from "antd";
import { useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

import classes from "./ReCaptcha.module.scss";

export default function ReCaptcha({ value, onChange }) {
  const reCaptchaRef = useRef();

  const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  useEffect(() => {
    if (!value && reCaptchaRef.current) {
      reCaptchaRef.current.reset();
    }
  }, [value]);

  return (
    <Form.Item
      name="captcha"
      rules={[
        {
          validator: (_) => {
            if (!value) {
              return Promise.reject(new Error("You must solve the CAPTCHA"));
            }
            return Promise.resolve();
          },
          message: "You must solve the CAPTCHA",
        },
      ]}
    >
      <div className={classes.reCaptchaWrapper}>
        <ReCAPTCHA
          ref={reCaptchaRef}
          sitekey={SITE_KEY}
          onChange={onChange}
          onExpired={() => onChange(null)}
        />
      </div>
    </Form.Item>
  );
}
